<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <!-- 我的余额 -->
          <div class="ttshop_balance min_h">
            <div class="ttshop_balanceup clearfloat">
              <div class="ttshop_balanceupleft">
                <h5>我的余额</h5>
                <h4>{{list.money}}</h4>
              </div>
              <!-- <div class="ttshop_balanceupright">
                <router-link to="/ttshop_recharge">充值</router-link>
              </div> -->
            </div>

            <div class="ttshop_balancebut">
              <div class="ttshop_balancetitle clearfloat">
                <div class="ttshop_balanleft">
                  <div class="ttshop_myordertexter clearfloat">
                    <el-dropdown @command="handleCommand" style="width: 74px;">
                      <p v-if="commandNum ==1">本月</p>
                      <p v-if="commandNum ==2">近一周</p>
                      <p v-if="commandNum ==3">近一个月</p>
                      <i><img class="img-default" src="../../assets/images/ttshop_orderxl.png" alt=""></i>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command='1'>本月</el-dropdown-item>
                        <el-dropdown-item command='2'>近一周</el-dropdown-item>
                        <el-dropdown-item command='3'>近一个月</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
                <div class="ttshop_balanconter">
                  <div class="ttshop_myorderzts  clearfloat">
                    <p>全部类型</p>
                    <!-- <el-dropdown>
                      <p>全部类型</p>
                      <i><img class="img-default" src="../../assets/images/ttshop_orderxl.png" alt=""></i>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>购买商品</el-dropdown-item>
                        <el-dropdown-item>充值</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown> -->
                  </div>
                </div>
                <div class="ttshop_balanlast">
                  <p>金额</p>
                </div>
              </div>
              <!-- 暂无消费记录 -->
              <div class="ttshop_zuxiaofei" v-show="recordList == null">
                <img class="img-default" src="../../assets/images/ttshop_zanwu.png" alt="">
                <p>您目前暂无消费记录</p>
              </div>
              <div class="ttshop_balanlist">
                <ul>
                  <li class="clearfloat" v-for="(item,index) in recordList" :key="index">
                    <p class="ttshop_balantime">{{item.date}}</p>
                    <p class="ttshop_balantext">{{item.content}}</p>
                    <p class="ttshop_balanlistlast">{{item.price}}</p>
                  </li>
                </ul>
              </div>
              <div v-show="pageShow">
                <div class="ttshop_myorderpage clearfloat" v-show=" recordList != null">
                  <el-pagination class="ttshop_pages" background @prev-click="pages_perv" @next-click="page_next" layout="prev, pager, next" :page-count="page_count"></el-pagination>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      list: "",
      recordList: [],
      commandNum: 1,
      page_count: 1,
      page: 1,
      gettime: "",
      pageShow: true,
    };
  },
  mounted() {
    this.rechargeIndex();
    this.getTime();
  },
  methods: {
    getTime() {
      let _this = this;
      let yy = new Date().getFullYear();
      let mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      let hh =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      _this.gettime = yy + "-" + mm;
    },
    // 展示数据
    rechargeIndex() {
      let data;
      if (this.commandNum == 1) {
        data = {
          date: this.gettime,
          page: this.page,
          type: 0,
        };
      } else {
        data = {
          day: this.commandNum,
          page: this.page,
          type: 0,
        };
      }
      this.$api
        .rechargeIndex(data)
        .then((res) => {
          console.log(res.data);
          this.list = res.data;
          this.recordList = res.data.list;
          this.page_count = res.data.page_count;
          if (res.data.page_count == 1) {
            this.pageShow = false;
          }
        })
        .catch((err) => {
          console.log(err);
          // this.user = err;
        });
    },
    handleCommand(command) {
      // this.$message('click on item ' + command);
      this.commandNum = command;
      this.rechargeIndex();
    },
    //上一页
    pages_perv() {
      this.page--;
      this.rechargeIndex();
    },
    // 下一页
    page_next() {
      this.page++;
      this.rechargeIndex();
    },
  },
};
</script>

<style  lang="scss" scoped>
.ttshop_balance {
  width: 100%;
  background: #fff;
  padding-bottom: 20px;
  box-sizing: border-box;
  .ttshop_balanceup {
    width: 100%;
    padding: 40px;
    box-sizing: border-box;
    .ttshop_balanceupleft {
      float: left;
      margin-right: 70px;
      h5 {
        font-size: 16px;
        color: #666;
        font-weight: 500;
        line-height: 16px;
        margin-bottom: 12px;
      }
      h4 {
        font-size: 32px;
        color: #666;
        font-weight: 600;
        line-height: 32px;
      }
    }
    .ttshop_balanceupright {
      float: left;
      padding-top: 14px;
      box-sizing: border-box;
      a {
        display: block;
        width: 116px;
        height: 32px;
        border-radius: 2px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        color: #fff;
        background: #ff0e25;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;
        &:hover {
          box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
        }
      }
    }
  }

  .ttshop_balancebut {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    .ttshop_zuxiaofei {
      width: 100%;
      padding-top: 150px;
      // display: none;
      box-sizing: border-box;
      img {
        display: block;
        width: 93px;
        height: 80px;
        margin: 0 auto 20px;
      }
      p {
        font-size: 16px;
        color: #333;
        text-align: center;
      }
    }
    .ttshop_balancetitle {
      width: 100%;
      height: 32px;
      background: #f5f5f5;
      .ttshop_balanleft {
        float: left;
        width: 45%;
        padding-left: 24px;
        padding-top: 8px;
        box-sizing: border-box;
        .ttshop_myordertexter {
          display: table;
          cursor: pointer;
          position: relative;
          p {
            float: left;
            font-size: 12px;
            color: #333;
          }
          i {
            float: left;
            width: 12px;
            height: 12px;
            margin-top: 2px;
            img {
              display: block;
              width: 100%;
            }
          }
        }
      }
      .ttshop_balanconter {
        float: left;
        width: 30%;
        padding-top: 8px;
        box-sizing: border-box;
        .ttshop_myorderzts {
          // cursor: pointer;
          p {
            float: left;
            font-size: 12px;
            color: #333;
          }
          i {
            float: left;
            width: 12px;
            height: 12px;
            margin-top: 2px;
            img {
              display: block;
              width: 100%;
            }
          }
        }
      }
      .ttshop_balanlast {
        float: left;
        width: 25%;
        padding-top: 8px;
        padding-right: 24px;
        box-sizing: border-box;
        p {
          font-size: 12px;
          color: #333;
          text-align: right;
        }
      }
    }
    .ttshop_balanlist {
      width: 100%;
      ul {
        li {
          width: 100%;
          height: 40px;
          border: 1px solid #ebebeb;
          border-top: 0;
          box-sizing: border-box;
          line-height: 40px;
          .ttshop_balantime {
            float: left;
            width: 45%;
            padding-left: 24px;
            box-sizing: border-box;
            font-size: 12px;
            color: #333;
          }
          .ttshop_balantext {
            float: left;
            width: 30%;
            font-size: 12px;
            color: #333;
          }
          .ttshop_balanlistlast {
            float: left;
            width: 25%;
            font-size: 12px;
            color: #333;
            text-align: right;
            padding-right: 24px;
            box-sizing: border-box;
          }
        }
      }
    }
    .ttshop_myorderpage {
      width: 100%;
      margin-top: 32px;
      .ttshop_pages {
        float: right;
      }
    }
  }
}
</style>
